export const getLastPageAccessTime = () => {
  let previousPageAccessTimeUnserialised = sessionStorage.getItem('LAST_PAGE_ACCESS_TIME')
  if (previousPageAccessTimeUnserialised) {
    try {
      return JSON.parse(previousPageAccessTimeUnserialised)
    } catch (e) {
      return null
    }
  }
}
